import { render, staticRenderFns } from "./Tg.vue?vue&type=template&id=e3a875a8&scoped=true&"
import script from "./Tg.vue?vue&type=script&lang=js&"
export * from "./Tg.vue?vue&type=script&lang=js&"
import style0 from "./Tg.vue?vue&type=style&index=0&id=e3a875a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a875a8",
  null
  
)

export default component.exports